import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientsServices } from '../../ingredients/services';
import { Globals } from '../../../globals';
import { ConfigurationServices } from '../../configuration/services';
import { ProductsServices } from '../../products/services';
import { StaticsServices } from '../../services/statics';


@Component({
  selector: 'page-complements-create-select',
  templateUrl: 'complements-create-select.html',
})
export class ComplementsCreateSelectPage {

  update_state: boolean = false;
  dish_uid: string;
  dish_name: string;
  fav_variations: any;
  origin: string;
  product_uid: string;
  product_name: string;
  dish: any;
  product: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public toastCtrl: ToastController,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public productsServices: ProductsServices,
    public staticsServices: StaticsServices) {

    this.update_state = this.navParams.get('update');
    this.origin = this.navParams.get('origin');
    this.fav_variations = this.navParams.get('fav_variations');
    //dish
    this.dish_uid = this.navParams.get('dish_uid');
    this.dish_name = this.navParams.get('dish_name');
    this.dish = this.navParams.get('dish');
    //product
    this.product_uid = this.navParams.get('product_uid');
    this.product_name = this.navParams.get('product_name');
    this.product = this.navParams.get('product');
  }

  async ngOnInit() {
    this.configurationServices.getPagesVariations();

    //reniciar variable
    this.configurationServices.complements_groups_selected = Array();

    if (this.update_state) {
      if (this.fav_variations != null) {
        if (this.fav_variations.length > 0) {
          this.configurationServices.complements_groups_selected = Array(); //Reiniciamos array para no tener los antiguos valores.
          for (let entry of this.fav_variations) {
            //Recuperamos el grupo de complementos
            await this.configurationServices.firestore.collection('complements_groups').doc(entry.uid).get().then(doc => {
              var v = doc.data();
              if (v) {
                this.configurationServices.complements_groups_selected.push({ ...doc.data(), UID: entry.uid, pos_active: entry.pos_active || false, tk_active: entry.tk_active || false });
              }
            });
          }
        }
      }
    } else {
      this.fav_variations = Array();
      this.configurationServices.complements_groups_selected = Array();
    }
    this.configurationServices.complements_groups_selected = [...this.configurationServices.complements_groups_selected];
  }

  openSaveComplements() {
    //init
    var _array = Array();
    //recorer listado fav_variations_array_tmp
    for (var i = 0; this.configurationServices.complements_groups_selected.length > i; i++) {
      //crear y push de variaciones favs
      _array.push({
        uid: this.configurationServices.complements_groups_selected[i].UID,
        pos_active: this.configurationServices.complements_groups_selected[i].pos_active || false,
        tk_active: this.configurationServices.complements_groups_selected[i].tk_active || false,
        name_static: this.globals.nameNotEsLang(this.configurationServices.complements_groups_selected[i]),
        type_static: 'group',
      });
    }
    //miramos si es plato o producto y editamos en firestore
    if (this.origin === 'dish') {//caso plato
      this.ingredientsServices.afs.collection('dish').doc(this.dish_uid).update({
        'variations_favourite': _array,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        this.globals.GAtrackView('Dish', 'Dish - Variations favourite - Update', this.globals.restaurant.email, 'Create/Update', 'Update variations favourite', 'Dish', this.dish_name);
        this.configurationServices.complements_groups_selected = Array();
        this.navCtrl.pop();
      });
    } else {//caso plato producto
      this.productsServices.afs.collection('products').doc(this.product_uid).update({
        'variations_favourite': _array,
        'updated_at': new Date(),
        'updated_user': this.globals.user_name
      }).then(() => {
        this.globals.GAtrackView('Products', 'Products - Variations favourite - Update', this.globals.restaurant.email, 'Create/Update', 'Update variations favourite', 'Products', this.product_name);
        this.configurationServices.complements_groups_selected = Array();
        this.navCtrl.pop();
      });
    }
    this.staticsServices.changeStateStaticWait(true);
  }

  searchVariationsNode(value) {
    this.configurationServices.searchVariationsNode(value);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/complements/complements-create-select/complements-create-select.ts